export var mutations = {
    setMolJob: function (s, payload) { return s.molJob = payload; },
    setPresets: function (s, payload) { return s.presets = payload; },
};
